import React, { useEffect } from 'react';
import SmoothScroll from 'smooth-scroll';
import AuthDialogContextProvider from '../../front/components/AuthDialog/AuthDialogContextProvider';
import LocalDeliveryComponent from './components';
import { OTETSUTABI_LIST_DATA } from './constants';

const LocalDelivery = ({
  plans,
  onAirBusinesses,
  businesses,
  authenticated,
}) => {
  useEffect(() => {
    new SmoothScroll('a[href*="#"]');
  }, []);
  const onAirList = OTETSUTABI_LIST_DATA.map(({ key, ...data }) => {
    const onAirBusiness = onAirBusinesses.find((oab) => oab.key === key);
    const business = businesses.find((b) => b.id === onAirBusiness?.id);
    return { ...data, business };
  });
  return (
    <AuthDialogContextProvider>
      <LocalDeliveryComponent
        plans={plans}
        onAirList={onAirList}
        authenticated={authenticated}
      />
    </AuthDialogContextProvider>
  );
};

export default LocalDelivery;
